@for (col of columns; track col) {
  @if (col.children?.length) {
    <th [attr.colspan]="col.children.length">
      {{ col.title }}
    </th>
  }
  @if (!col.children?.length) {
    <th>{{ col.title }}</th>
  }
}

@if (columns[0]?.children?.length) {
  <tr>
    <app-dynamic-header [columns]="getChildColumns()"></app-dynamic-header>
  </tr>
}